<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <p-toast [style]="{ marginTop: '80px' }"></p-toast> -->
    <p-accordion expandIcon="pi pi-chevron-circle-down" [multiple]="true" collapseIcon="pi pi-chevron-circle-up">
      <!-- ------------TAB 1---------- -->
      <p-accordionTab header="INNOVATOR/BRAND PRODUCT DETAILS" [selected]="true">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionOneData | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key === 'Brand Name/Proprietary Name' || Obj.key === 'Dosage forms' || Obj.key === 'NDA number'?
                  Obj.key + ' *':Obj.key}}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text"
                                (change)="editdata('sectionOne',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                                value="{{rdata }}" id={{rdata}}>
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'sectionOne')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionOne')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionOne',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionOne')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionOne')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionOne',$event,Obj.value,Obj.key,index,'')">
                  </p>


                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
            <!-- <button type="submit" (click)="saveEdit()">save</button>                                            -->
          </tbody>
        </table>


      </p-accordionTab>

      <!-- -------------TAB 2--------- -->
      <p-accordionTab header="PATENT INFORMATION">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionTWOdata | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text"
                                (change)="editdata('sectionTwo',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                                value="{{rdata }}">
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionTwo')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionTwo')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionTwo',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionTwo')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionTwo')"></i>

                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionTwo',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>


      <!-- -------------TAB 3--------- -->
      <p-accordionTab header="REGULATORY INFORMATION">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionThreeData | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text" value="{{rdata }}"
                                (change)="editdata('sectionThree',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)">
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionThree')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionThree')"></i>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionThree',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionThree')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionThree')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionThree',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>

      <!-- -------------TAB 4--------- -->
      <p-accordionTab header="CLINICAL INFORMATION">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionFourdata | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text" value="{{rdata }}"
                                (change)="editdata('sectionFour',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)">
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionFour')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionFour')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionFour',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionFour')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionFour')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionFour',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>

      <!-- -------------TAB 5--------- -->
      <p-accordionTab header="API INFORMATION">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionFiveData | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text" value="{{rdata }}"
                                (change)="editdata('sectionFive',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)">
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionFive')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionFive')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionFive',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionFive')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionFive')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionFive',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>

      <!-- -------------TAB 6--------- -->
      <p-accordionTab header="FORMULATION INFORMATION">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionSixdata | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text" value="{{rdata }}"
                                (change)="editdata('sectionSix',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)">
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionSix')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionSix')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionSix',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionSix')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionSix')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionSix',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>

      <!-- -------------TAB 7--------- -->
      <p-accordionTab header="COMPETITIVE INTELLIGENCE">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionSevenData | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text" value="{{rdata }}"
                                (change)="editdata('sectionSeven',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)">
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionSeven')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionSeven')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionSeven',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionSeven')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionSeven')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionSeven',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>

      <!-- -------------TAB 8--------- -->
      <p-accordionTab header="EXECUTIVE SUMMARY">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionEightdata | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text" value="{{rdata }}"
                                (change)="editdata('sectionEight',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)">
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionEight')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionEight')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionEight',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionEight')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionEight')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionEight',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>

              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>

      <!-- -------------TAB 9--------- -->
      <p-accordionTab header="COSTING RELATED & OTHERS">
        <table class="table table-bordered" style="width: 100%; color: #3A4B64;">
          <tbody>
            <tr *ngFor="let Obj of sectionNinthdata | Object2keyvalue; let index=index">
              <td #headerids class="td-left">
                <div>
                  {{Obj.key }}
                </div>
              </td>

              <td style="padding-top: 20px;" class="td-right">
                <div *ngIf="Obj.value | arrayChk;else displayvalue;">
                  <div *ngIf="Obj.value | tableChk;else list">
                    <div class="table-responsive">
                      <table class="table table-bordered" id="innertable" style="width: 100%; ">
                        <thead style="font-size: 12px; background-color: #EDF0F4;">
                          <tr>
                            <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader"
                              style="width: auto;">
                              <p>{{headers}}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                          <tr *ngFor="let trows of Obj.value | tableBody | slice:0:sliceEnd;let m=index">
                            <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                              <input type="text"
                                (change)="editdata('sectionNine',$event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                                value="{{rdata }}" id={{rdata}}>
                            </td>
                          </tr>
                          <i style="font-size: 20px;" class="fas fa-plus float-left"
                            (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key, 'sectionNine')"></i>

                          <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                            (click)="deleteItems(Obj.value,Obj.key,'sectionNine')"></i>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #list>
                    <ul>
                      <li *ngFor="let lItems of Obj.value | slice:0:sliceEnd;let inds=index">
                        <p><input type="text" value="{{lItems}}"
                            (change)="editdata('sectionNine',$event,Obj.value,Obj.key,lItems,inds,'lItems')"></p>
                      </li>
                      <i style="font-size: 20px;" class="fas fa-plus float-left"
                        (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key,'sectionNine')"></i>

                      <i style="font-size: 20px; margin-left: 50px;" class="fas fa-minus float-left"
                        (click)="deleteListItem(Obj.value,Obj.key,'sectionNine')"></i>
                    </ul>
                  </ng-template>
                </div>

                <ng-template #displayvalue>
                  <p
                    [ngClass]="[ Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                    <input type="text" value="{{Obj.value}}"
                      (change)="editdata('sectionNine',$event,Obj.value,Obj.key,index,'')">
                  </p>

                  <!-- <i [ngClass]="[ Obj.key ==='FDA label'?'editcls':'editdisable']"
                        (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->

                  <!-- <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                           class="fa fa-file-pdf-o" style="font-size: 30px;"></i> -->
                  <!-- <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div> -->
                  <!-- <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div> -->
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </p-accordionTab>
    </p-accordion>

    <button class="btn btn-primary" style="margin-top:2rem;" type="submit" (click)="saveEdit()">save</button>

  </div>
</div>